<template>
    <v-container>
      <h1 class="text-h4 mb-4">Duyurular</h1>
  
      <v-row class="mb-4">
          <v-col cols="12" md="6">
               <v-text-field
                 v-model="searchQuery"
                 label="Duyurularda Ara..."
                 prepend-inner-icon="mdi-magnify"
                 variant="outlined"
                 dense
                 hide-details
                 clearable
                 @input="debouncedFetchAnnouncements"
                 @click:clear="clearSearch"
              ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
               <v-checkbox
                 v-model="showVerifiedOnly"
                 label="Sadece Onaylı İlanlar"
                 dense
                 hide-details
                 @change="fetchAnnouncements(1)"
              ></v-checkbox>
          </v-col>
           <v-col cols="12" md="3" class="text-right">
               <v-btn color="primary" to="/announcements/new">
                   <v-icon left>mdi-plus</v-icon> Yeni İlan Ekle
               </v-btn>
          </v-col>
      </v-row>
  
  
      <v-row v-if="loading" justify="center">
        <v-col cols="auto">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
          <p class="mt-2 text-center">Duyurular yükleniyor...</p>
        </v-col>
      </v-row>
  
      <v-row v-else-if="error">
          <v-col cols="12">
              <v-alert type="error" prominent>
                  Duyurular yüklenirken bir hata oluştu: {{ error }}
                  <v-btn @click="fetchAnnouncements(1)" small class="ml-4">Tekrar Dene</v-btn>
              </v-alert>
          </v-col>
       </v-row>
  
      <v-row v-else-if="announcements.length > 0">
        <v-col
          v-for="announcement in announcements"
          :key="announcement.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <AnnouncementCard :announcement="announcement" />
        </v-col>
      </v-row>
  
       <v-row v-else>
          <v-col cols="12" class="text-center grey--text mt-5">
              <v-icon size="50">mdi-database-search-outline</v-icon>
              <p class="mt-2">Gösterilecek duyuru bulunamadı.</p>
              <v-btn v-if="searchQuery || showVerifiedOnly" @click="resetFilters" small color="secondary" class="mt-3">Filtreleri Temizle</v-btn>
          </v-col>
       </v-row>
  
  
      <v-row v-if="totalPages > 1" justify="center" class="mt-5">
        <v-col cols="auto">
          <v-pagination
            v-model="currentPage"
            :length="totalPages"
            :total-visible="7"
            @update:modelValue="fetchAnnouncements"
          ></v-pagination>
        </v-col>
      </v-row>
  
    </v-container>
  </template>
  
  <script>
  import AnnouncementCard from '@/components/AnnouncementCard.vue';
  import announcementService from '@/services/announcementService';
  import _ from 'lodash'; // Debounce için lodash (npm install lodash)
  
  export default {
    name: 'AnnouncementsList',
    components: {
      AnnouncementCard
    },
    data() {
      return {
        announcements: [],
        loading: false,
        error: null,
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        searchQuery: '',
        showVerifiedOnly: false,
        itemsPerPage: 12, // Sayfa başına ilan sayısı
      };
    },
    methods: {
      async fetchAnnouncements(page = this.currentPage) {
        this.loading = true;
        this.error = null;
        this.currentPage = page; // Sayfa numarasını güncelle
  
        const params = {
            page: this.currentPage,
            limit: this.itemsPerPage,
            verified: this.showVerifiedOnly ? 'true' : undefined, // Sadece true ise gönder
            search: this.searchQuery || undefined, // Boşsa gönderme
        };
  
        try {
          const response = await announcementService.getAnnouncements(params);
          this.announcements = response.data.announcements;
          this.totalPages = response.data.totalPages;
          this.totalItems = response.data.totalItems;
        } catch (err) {
          this.error = err.response?.data?.message || 'Duyurular alınamadı.';
          console.error(err);
        } finally {
          this.loading = false;
        }
      },
      // Arama inputunda hızlı yazmayı beklemek için debounce
       debouncedFetchAnnouncements: _.debounce(function() { this.fetchAnnouncements(1); }, 500), // 500ms bekle
  
       clearSearch() {
           this.searchQuery = '';
           this.fetchAnnouncements(1);
       },
        resetFilters() {
           this.searchQuery = '';
           this.showVerifiedOnly = false;
           this.fetchAnnouncements(1);
        }
    },
    created() {
      // Component oluşturulduğunda ilk sayfayı yükle
      this.fetchAnnouncements(1);
    }
  };
  </script>